export default "__VITE_ASSET__D6P1mDo9__"